import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Icons } from '@/utils/Icons';
import { useLockBodyScroll } from '@/hooks';
import UnsettledBet from '@/pages/Reports/UnsettledBet';

interface UnsettledBetModalProps {
  open: boolean;
  onClose: () => void;
}

const UnsettledBetModal = ({ open, onClose }: UnsettledBetModalProps) => {
  const { t } = useTranslation();
  useLockBodyScroll(open);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-start justify-center bg-black/60 pt-8 px-2">
      <div className="relative bg-white dark:bg-darkPanelBg rounded-[6px] shadow-2xl w-full md:w-[90vw] max-h-[85vh] flex flex-col">
        <button
          onClick={onClose}
          className="absolute top-1.5 right-1.5 md:top-2.5 md:right-3 z-10 text-black hover:opacity-70"
        >
          <Icons.Cross2 size={14} />
        </button>

        <div className="overflow-y-auto flex-1">
          <UnsettledBet />
        </div>

        {/* Footer */}
        <div className="flex justify-center py-3 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={onClose}
            className="px-3 py-1 border border-red-500 text-red-500 rounded text-[13px] hover:bg-red-50"
          >
            {t('reports.unsettledBetModal.cancel')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnsettledBetModal;
